import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { bool, func } from "prop-types";
import { reduxForm } from "redux-form";
import compose from "ramda/src/compose";
import { Form, Modal, FloatLabelSelect, Button } from "shared/components";
import styles from "../styles.css";
import IconRepair from "../../../assets/svg/icone-reparo-modal.svg";
import { selectReason } from "../../../services/state/actions";

class ModalSelectReason extends Component {
  state = {
    reason: this.props.reasons && this.props.reasons[0],
    invalid: false,
  };

  onChangeSelect = (event) => {
    const reason = event.target.value;
    if (!reason) return null;
    if (this.state.reason !== reason) {
      this.setState((prevState) => ({ reason }));
    }
  };

  onSubmit = () => {
    const { selectReason, onNextStep } = this.props;
    const { reason } = this.state;
    if (!reason) {
      this.setState({ invalid: true });
      return;
    }

    selectReason(reason);
    onNextStep();
  };

  render() {
    const {
      t,
      isCurrentStep,
      onPreviousStep,
      reasons,
      handleSubmit,
    } = this.props;
    const mappedReasons = reasons.map(({ reasonCode, reasonName }) => ({
      value: reasonCode,
      label: reasonName,
    }));

    return (
      <Modal
        isOpen={isCurrentStep}
        onClose={onPreviousStep}
        title={t("MSG_0194")}
        icon={IconRepair}
        ariaHideApp={false}
        noOverflow
      >
        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <fieldset>
            <FloatLabelSelect
              id="problemReason"
              label={t("MSG_0216")}
              options={mappedReasons}
              onChange={this.onChangeSelect}
              invalid={this.state.invalid}
            />
          </fieldset>
          <div className={styles.actions}>
            <Button onClick={onPreviousStep} relevance="low" toLinkBtn>
              {t("MSG_0292")}
            </Button>
            <Button type="submit" relevance="normal" callToAction>
              {t("MSG_0126")}
            </Button>
          </div>
        </Form>
      </Modal>
    );
  }
}

ModalSelectReason.propTypes = {
  onCancel: func,
  onNextStep: func,
  isOpen: bool,
};

ModalSelectReason.defaultProps = {
  isOpen: false,
  onCancel: () => {},
  onNextStep: () => {},
  reasons: [],
};

function validate(values) {
  const error = {};
  return error;
}

const mapStateToProps = ({ repair }) => ({
  reasons: repair.wizard.reasons,
});

const reduxFormConfig = {
  form: "ModalSelectReason",
  validate,
};

const enhance = compose(
  translate(),
  reduxForm(reduxFormConfig),
  connect(mapStateToProps, { selectReason })
);

export default enhance(ModalSelectReason);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalSelectReason.js